import { Typography } from "@mui/material";
import { usePostHog } from "posthog-js/react";

import { NewTabLink } from "components/NewTabLink";
import {
  CARRIER_UPGRADE_RELATIVE_URL,
  CarrierUpgradeSource,
  ClientAppEvent,
} from "constants/index";
import { captureCarrierUpgradeCtaClicked } from "utils";

interface ShipperBookingSpeedTeaserProps {
  shipperRoleId: number;
}

export function ShipperBookingSpeedTeaser(
  props: ShipperBookingSpeedTeaserProps,
) {
  const { shipperRoleId } = props;
  const posthog = usePostHog();

  const onTeaserClick = () => {
    posthog?.capture(ClientAppEvent.SHIPPER_BOOKING_STATS_TEASER_CLICKED, {
      shipper_role_id: shipperRoleId,
    });
    captureCarrierUpgradeCtaClicked(
      posthog,
      CarrierUpgradeSource.AVG_BOOKING_TEASER,
      { shipper_role_id: shipperRoleId },
    );
  };

  return (
    <NewTabLink href={CARRIER_UPGRADE_RELATIVE_URL} onClick={onTeaserClick}>
      <Typography>
        Upgrade to view the shipper&apos;s average booking time
      </Typography>
    </NewTabLink>
  );
}
